import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_7: FaireProductEntity = {
  token: "sweet-wink-7",
  type: "product",
  name: "Heart Floral Trellis Valentine's Day Women's Lounge Set",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/d3cd0ba5aa6b2194c9e64b6863b3373baa9b56331c6db10739320ae3a0c1f86e.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 28,
  msrpDollars: 56,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
